export const PPM_TYPE_OPTIONS = [
  'Weekly',
  'Monthly',
  'Quarterly',
  'Bi-Annually',
  'Annually',
];

export const PDF_TEMPLATES = {
  'Weekly': '/QDFTemplates/QDF_PPM_Weekly.pdf',
  'Monthly': '/QDFTemplates/QDF_PPM_Monthly.pdf',
  'Quarterly': '/QDFTemplates/QDF_PPM_Quarterly.pdf',
  'Bi-Annually': '/QDFTemplates/QDF_PPM_BiAnnual.pdf',
  'Annually': '/QDFTemplates/QDF_PPM_Annual.pdf',
  'Corrective': '/QDFTemplates/QDF_CM.pdf',
};

export const SC_STATUS_OPTIONS = [
  'Active', 'Closed', 'On Hold', 'Cancelled',
];

export const PRIORITY_OPTIONS = ['High', 'Medium', 'Low', 'None'];

export const SERVICE_REQUEST_DESCRIPTION_OPTIONS = [
  'Music too loud',
  'Music too low',
  'Music not playing',
  'Music did not pause during CTP',
];

export const LOCATIONS = [
  'South Node',
  'North Node',
  'Central Concourse',
  'D&E Expansion',
];

export const DEPARTMENTS = [
  'Fashion & Accessories',
  'Food & Beverage',
  'Retail & Other',
];

export const ZONE_OPTIONS = {
  'South Node': ['1A', '1B', '1C'],
  'North Node': ['1', '2'],
  'Central Concourse': ['1A', '1B', '2'],
  'D&E Expansion': ['1D', '2E'],
};
